import { render } from "./ProfileButton.vue?vue&type=template&id=82edfeaa"
import script from "./ProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "82edfeaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82edfeaa', script)) {
    api.reload('82edfeaa', script)
  }
  
  module.hot.accept("./ProfileButton.vue?vue&type=template&id=82edfeaa", () => {
    api.rerender('82edfeaa', render)
  })

}

script.__file = "src/ui/buttons/ProfileButton.vue"

export default script